const mobileRegex = new RegExp(/^(?:(?:(?:00\s?|\+)44\s?|0)7(?:[345789]\d{2}|624)\s?\d{3}\s?\d{3})$/)
const cleanPhoneNumber = (phone: string) => phone.replace(/\s/g, '').replace(/[^0-9+]/g, '').replace(/(^(\+*44|0044))/g, '0')

const isMobile = (phone: string) => mobileRegex.test(phone)

export interface AppFormPhone {
  valueField: string
  typeField: 'MOBILE' | 'HOME'
}

export const mapToPhone = (phone: string): AppFormPhone => {
  const cleanedPhone = cleanPhoneNumber(phone)
  return {
    valueField: cleanedPhone,
    typeField: isMobile(cleanedPhone) ? 'MOBILE' : 'HOME'
  }
}
